import * as dependencies from '@/dependencies';
import '@/setSharedDependencies'; // set shared-lib dependencies

import router from '@/router';

import App from '@/App.vue';
dependencies.Vue.config.productionTip = false;

/* eslint-disable no-new */
const vueInstance = new dependencies.Vue({
    router,
    i18n: dependencies.i18n,
    render: h => h(App),
}).$mount('#app');

export { vueInstance, dependencies, router };

